import * as sensorReadingUnit from "../sensors/sensorReadingUnitKeys";

export default sensors => {
  let sensorId = null;

  if (sensors && sensors.length > 0) {
    sensorId = sensors[0].sensorId;
    const kWhSensors = sensors.filter(
      sensor => sensor.unit.description === sensorReadingUnit.KWH
    );

    if (kWhSensors && kWhSensors.length > 0) {
      sensorId = kWhSensors[0].sensorId;
    }
  }

  return sensorId;
};
